import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { TipoClassificacaoMultiselectModule } from '../../tipo-classificacao/multiselect';
import { CrossSellMultiselectModule } from '../../common/cross-sell/components/multiselect';

import { ClassificacaoFilterComponent } from './classificacao-filter.component';

@NgModule({
    imports: [
        SharedModule,
        TipoClassificacaoMultiselectModule,
        CrossSellMultiselectModule
    ],
    declarations: [
        ClassificacaoFilterComponent
    ],
    exports: [
        ClassificacaoFilterComponent
    ]
})
export class ClassificacaoFilterModule { }
